import { useQuery } from "react-query";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

export interface IGetNewResponseCodeRequest {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  status?: string;
  filters?: {
    field: string;
    values: string[];
    valueType: number;
    operationType: number;
  }[];
}

export interface INewResponseCode {
  id: number;
  bankCode: string;
  errorCode: string;
  errorCodeDesc: string;
  isConverted: boolean;
  bankName: string;
  isIncludeResponseCode: boolean;
}

export interface IGetNewResponseCodeResponse {
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalItems: number;
  orderBy: string;
  orderByDesc: boolean;
  result: INewResponseCode[];
}

async function getNewResponseCodes(
  params: IGetNewResponseCodeRequest
): Promise<IGetNewResponseCodeResponse> {

  params.filters?.push({
    field: "status",
    values: ["ACTIVE"],
    valueType: 1,
    operationType: 6,
  });

  const { data } = await axiosInstance.post("/ResponseCode/GetNewResponseCodes", params);
  return data.data;
}

export function useGetNewResponseCodes(params: IGetNewResponseCodeRequest) {
  return useQuery(
    [QueryKeys.newResponseCodes, params],
    () => getNewResponseCodes(params),
    {
      enabled: false,
    }
  );
}
